import { CalendarTodayOutlinedIcon, NoRowsOverlay } from '@shared/components';

export default function EmptyUpcomingExamEventOverlay() {
  return (
    <NoRowsOverlay
      icon={CalendarTodayOutlinedIcon}
      title='ยังไม่มีรอบสอบที่กำลังมาถึง'
      description='ระบบจะแสดงรอบสอบหลังจากศูนย์สอบเพิ่มข้อมูลแล้ว'
    />
  );
}
